// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class Engagement extends TrackingModel {
	public EngagementId: number = 0;
	public ResourceId: number = 0;
	public ProductionId: number = 0;
	public ProductionRoleId?: number;
	public EngagementStatusId?: number;
	public AvatarBlobPath?: string;
	public StartOnUTC?: Date;
	public GeoLocation?: string;
}